import { TransactionStatusEnum } from "../../../"

export class CheckPaymentStatusResponseDTO {
    status: TransactionStatusEnum
    constructor(
        status: TransactionStatusEnum
    ) {
        this.status = status
    }
}

